export const locales = ["fr", "en", "pt"] as const;
export const defaultLocale = "fr" as const;

export type Locale = (typeof locales)[number];

export const routeTranslations = {
  cookies: {
    fr: "cookies",
    en: "cookies",
    pt: "cookies",
  },
  legal: {
    fr: "mentions-legales",
    en: "mentions-legales",
    pt: "mentions-legales",
  },
  reservation: {
    fr: "reservation",
    en: "reservation",
    pt: "reservation",
  },
  options: {
    fr: "options",
    en: "options",
    pt: "options",
  },
} as const;
